module.exports = __webpack_public_path__ + "img/add_wiretrans_tab.3ee2b54e.svg";